module.exports = __webpack_public_path__ + "static/media/agreement.ab07d7b0.md";